import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { useTranslation } from '@/hooks/useTranslations';
import { useOfferCard } from '@/hooks/useOfferCard';
import Trans from '@/components/tools/Trans';
import { useTransactionType } from '@/hooks/useTransactionType';
import { OFFER_CARD_HEADER_HEIGHT, OFFER_CARD_HEADER_HEIGHT_WITH_DISCOUNT, } from './constants';
export function OfferCardHeaderDesktop() {
    const { t } = useTranslation();
    const { transactionType } = useTransactionType();
    const { name, description, offerPrice, iconPath, iconAlt } = useOfferCard();
    const discountType = offerPrice === null || offerPrice === void 0 ? void 0 : offerPrice.discountType;
    const conditionedDescription = description !== 'offerCard.best.description'
        ? description
        : `${description}.${transactionType}`;
    return (_jsxs(Box, { testId: "offer-card-header-desktop", height: discountType
            ? OFFER_CARD_HEADER_HEIGHT_WITH_DISCOUNT
            : OFFER_CARD_HEADER_HEIGHT, padding: "spacing.16", flex: 0, flexBasis: discountType
            ? OFFER_CARD_HEADER_HEIGHT_WITH_DISCOUNT
            : OFFER_CARD_HEADER_HEIGHT, children: [_jsxs(Box, { display: "flex", alignItems: "center", testId: "offer-card-header-content-desktop", children: [_jsx(Box, { testId: "offer-card-header-icon-desktop", marginRight: "spacing.8", children: _jsx(Box, { as: "img", alt: t(iconAlt), src: iconPath }) }), _jsx(Box, { flex: "1", children: _jsx(Box, { testId: "offer-card-header-name-desktop", typography: "typography.headline.22.bold", children: t(name) }) })] }), _jsx(Box, { testId: "offer-card-header-description-desktop", typography: "typography.body.16.regular", marginTop: "spacing.8", children: _jsx(Trans, { translation: conditionedDescription, components: {
                        strong: _jsx("strong", {}),
                    } }) })] }));
}
